import React, { useState } from "react";
import { Grid, theme } from "antd";
import { HeaderMobile } from "../header/HeaderMobile";
import { BottomTabBar } from "./BottomTabBar";
import { DrawerMenu } from "./DrawerMenu";
import { ThemedLayoutV2 } from "@refinedev/antd";
import { ThemedTitleV2 } from "./title";
import { Header } from "../header";
import { ThemedSiderV2 } from "./sider";
import { ImpersonationBanner } from "./ImpersonationBanner";

interface MobileLayoutProps {
  children: React.ReactNode;
}

const MobileShell: React.FC<MobileLayoutProps> = ({ children }) => {
  const { token } = theme.useToken();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        backgroundColor: token.colorBgLayout,
      }}
    >
      <HeaderMobile onMenuOpen={() => setDrawerOpen(true)} />
      <ImpersonationBanner />
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          // Extra bottom padding so content isn't hidden behind the tab bar
          paddingBottom: 60,
        }}
      >
        {children}
      </div>
      <BottomTabBar onMoreOpen={() => setDrawerOpen(true)} />
      <DrawerMenu open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
};

/**
 * ResponsiveLayout renders MobileShell on small screens and the standard
 * ThemedLayoutV2 on desktop — desktop files stay completely untouched.
 */
export const ResponsiveLayout: React.FC<MobileLayoutProps> = ({ children }) => {
  const breakpoint = Grid.useBreakpoint();
  // Default to desktop until breakpoints are resolved (avoids flash)
  const isMobile =
    typeof breakpoint.lg === "undefined" ? false : !breakpoint.lg;

  if (isMobile) {
    return <MobileShell>{children}</MobileShell>;
  }

  return (
    <ThemedLayoutV2
      Header={() => <Header sticky />}
      Sider={(props) => <ThemedSiderV2 {...props} fixed />}
      Title={({ collapsed }) => (
        <ThemedTitleV2
          collapsed={collapsed}
          text=""
          icon={<img src="/images/logo.png" alt="logo" width={100} />}
        />
      )}
    >
      <ImpersonationBanner />
      {children}
    </ThemedLayoutV2>
  );
};
